import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAG: CultureInfo = {
  name: 'en-AG',
  displayName: 'English (Antigua & Barbuda)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AG',
  parent: CultureInfoEn
};
